import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from 'techlify-ng';

const routes: Routes = [
];
import { SchoolViewAllComponent } from "./school-view-all.component";
routes.push({ path: 'schools', component: SchoolViewAllComponent, canActivate: [AuthGuard] });

export const SchoolRoutingProvider = RouterModule.forRoot(routes, { useHash: true });